import React from 'react'

import http from 'utils/http'

import { KpiStyles } from 'components/styles/layouts/kpi/kpi.styles'

class KpiPage extends React.Component {
  state = {
    odometerValue: null,
  }

  componentDidMount() {
    const getMailboxes = () => {
      http
        .get('/members-api/profiles/kpi')
        .then((r) => this.setState({ odometerValue: r?.data?.count }))
    }
    if (!this.state.odometerValue) getMailboxes()
    this.timerId = setInterval(() => getMailboxes(), 5 * 60 * 1000)
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId)
    }
  }

  render() {
    const { odometerValue } = this.state
    return (
      <KpiStyles>
        <div className="kpi-page-container">
          <img className="app-logo" src={`${STATIC_BASE_URL}/static/webapp/images/ui-logo.png`} />
          <div className="center-container">
            <h1 className="app-title">Protected Mailboxes</h1>
            <div className="odometer">{odometerValue && odometerValue.toLocaleString()}</div>
          </div>
        </div>
      </KpiStyles>
    )
  }
}

export default KpiPage
